import Link from "./Link";
import React from "react";

const RedLink = (props) => {
  return <Link theme {...props} />;
};

export default RedLink;
